<template>
  <div class="flag_manage">
    <el-divider content-position="left">档案材料类型</el-divider>
    <el-row style="text-align: right; margin-bottom: 0.4rem">
      <el-col :span="24">
        <el-button type="primary" size="mini" @click="handleAddOpenService"
          >添加</el-button
        >
      </el-col>
    </el-row>
    <el-table
      height="calc(100vh - 286px)"
      :data="pageDataService"
      size="medium"
      border
      style="width: 100%"
    >
      <el-table-column label="id">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="档案材料类型">
        <template slot-scope="scope">
          {{ scope.row.record_name }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditService(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--    页码-->
    <div class="page-footer">
      <el-pagination
        background
        class="pagination-style"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOptionService.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOptionService.pageSize"
        :total="pageOptionService.total"
        @size-change="handleSizeChangeService"
        @current-change="handleCurrentChangeService"
      >
      </el-pagination>
    </div>
    <el-drawer
      title="添加"
      :visible.sync="AddDrawerService"
      :before-close="handleAddDrawerClose"
      size="30%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">档案内容名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入档案内容名称"
              :size="inputSize"
              v-model="addDataService.record_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAddService">添加</el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"
      :visible.sync="saveDrawerService"
      :before-close="handleSaveDrawerClose"
      size="30%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">档案内容名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请修改档案内容名称"
              :size="inputSize"
              v-model="saveRecordName"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleSaveService"
            >保存</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "record_detail",
  data() {
    return {
      record_index: "",
      saveRecordId: "",
      saveRecordName: "",
      inputSize: "small",
      detailTableData: [],
      addDataService: [],
      saveDataService: [],
      saveDrawerService: false,
      AddDrawerService: false,
      pageOptionService: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
    };
  },
  methods: {
    getDetailData() {
      this.$axios.get("/api/record/detail_list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.detailTableData = data.data.list;
          this.pageOptionService.total = this.detailTableData.length;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleEditService(index, datas) {
      this.record_index = index;
      this.saveRecordName = datas.record_name;
      this.saveRecordId = datas.id;
      this.saveDrawerService = true;
    },
    handleAddOpenService() {
      this.addDataService = [];
      this.AddDrawerService = true;
    },
    handleAddService() {
      if (!this.addDataService.record_name) {
        this.$message.error("服务名称不能为空");
        return;
      }
      this.$axios
        .post("/api/record/detail_create", {
          record_name: this.addDataService.record_name,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.detailTableData.unshift(data.data.row);
            this.pageOptionService.total = this.detailTableData.length;
            this.$message.success(data.msg);
            this.AddDrawerService = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleSaveService() {
      if (!this.saveRecordName) {
        this.$message.error("服务名称不能为空");
        return;
      }
      this.$axios
        .post("/api/record/detail_update/" + this.saveRecordId, {
          record_name: this.saveRecordName,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let index =
              this.pageOptionService.pageSize * (this.pageOptionService.currentPage - 1) +
              this.record_index;
            this.detailTableData[index].record_name = this.saveRecordName;
            this.pageOptionService.total = this.detailTableData.length;
            this.$message.success(data.msg);
            this.saveDrawerService = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleAddDrawerClose() {
      this.AddDrawerService = false;
    },
    handleSaveDrawerClose() {
      this.saveDrawerService = false;
      this.saveDataService.record_name = this.saveDataService.record_name;
    },
    handleSizeChangeService(val) {
      this.pageOptionService.pageSize = val;
    },
    handleCurrentChangeService(val) {
      this.pageOptionService.currentPage = val;
    },
  },
  computed: {
    pageDataService: {
      get: function () {
        return this.detailTableData.slice(
          this.pageOptionService.pageSize * (this.pageOptionService.currentPage - 1),
          this.pageOptionService.pageSize * this.pageOptionService.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  mounted() {
    this.getDetailData();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span {
  color: #5789F4;
  font-size: 0.36rem;
  font-weight: 400;
}
.flag_manage
  marginLeft()
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  overflow-y auto
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.flag_manage >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
/*.clues_manage >>> .el-table__header thead .is-hidden*/
/*  color: red*/
/*  background-color: #ECF4FF*/
/*  font-size 16px*/
.mb-10
  margin-bottom: .2rem
  margin-top: 0.4rem
.mt-10
  margin-top: .2rem
.level
  display flex
  align-items center
  position relative
  padding-right .32rem
  img
    width .32rem
    height .30rem
  .el-icon-question
    margin-left: .1rem
    color: #409EFF
    position absolute
    top 0
    right 0
    cursor pointer
.el-select, .el-cascader
  width: 100%
.count
  padding-left: .2rem
  line-height: .56rem
.el-position
  position relative
  .dot
    display inline-block
    width 0.1rem
    height 0.1rem
    border-radius 50%
    margin-right 0.1rem
    position absolute
    top 0
    left -.2rem
    bottom 0
    margin auto
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.changeHeight
  padding .2rem
  margin-top .4rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-collapse >>> .el-collapse-item__content
  padding-bottom 0
.el_dialogs >>> .el-dialog__body
  padding-left 0
  padding-right 0
.el_dialogs >>> .el-dialog__header
  padding 0

.block
  height 6rem
  overflow-y auto
  padding-top .2rem
  padding-left .2rem
  box-sizing border-box

  .time_right
    width 100%
    margin-top .4rem
    overflow hidden
    word-break break-all
    white-space normal
.el-timeline-item__node--large
  width .4rem
  height .4rem
/*滚动条整体样式*/
::-webkit-scrollbar{
  width: .1rem;/*竖向滚动条的宽度*/
  height: 10px;/*横向滚动条的高度*/
}
::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
  background: #cdcdcd;
  border-radius: 5px;
}
::-webkit-scrollbar-track{/*滚动条轨道的样式*/
  background: #f8f8f8;
  border-radius: 5px;
}
.el-date-editor
  width: 100% !important
</style>



// WEBPACK FOOTER //
// src/pages/record_detail/record_detail.vue